// extracted by mini-css-extract-plugin
export var navHoverIndicator = "Ltz8R";